import { ApiCore } from "./ApiCore";

export class VoyagerApi {
	private static _apiClient: ApiCore;

	public static get apiClient(): ApiCore {
		if (!VoyagerApi._apiClient) {
			throw new Error("API Client is not initiated");
		}

		return VoyagerApi._apiClient;
	}

	public static set apiClient(client: ApiCore) {
		VoyagerApi._apiClient = client;
	}

	public static async getVoyagerRedirectUrl(masterTrackingNo: string, origin: string): Promise<{url:string}> {
		return await VoyagerApi.apiClient.get("shipment/redirect",{masterTrackingNo: masterTrackingNo , path:"public", origin: origin}) as unknown as {url:string};
	}

}
